import styled from 'react-emotion';

const GridContainer = styled('div')`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 20px auto;
`;

export default GridContainer;



// WEBPACK FOOTER //
// ./src/elements/GridContainer.tsx